import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Modal, Button } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import { Edit, ThumbDown, ThumbUp } from "@material-ui/icons";
// import { createMuiTheme, withStyles, ThemeProvider } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
// import { approveCreativeAdmin, disapproveCreativeAdmin } from "../../../Actions/AdminCreativeActions";
import { 
  approveCPMForCampaign, disapproveCPMForCampaign 
} from "../../../Actions/campaignActions";
import { connect } from "react-redux";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

function EditCPMApprovalForCampaign(props) {

  // console.log("props :", props);
  const {data, approveCPMForCampaign, disapproveCPMForCampaign, } = props;

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const Approve = (data) => {
    approveCPMForCampaign(data);
    // console.log("Confirm Clicked!", data);
    handleClose();
  }

  const Disapprove = (data) => {
    
    disapproveCPMForCampaign(data);
    // console.log("Confirm Clicked!",data);
    handleClose();
  }

  const showButtons = (data) => {

    if(data.isCpmApprovedByAgency === true){

      return <div>
        <Button
              variant="contained"
              className={classes.margin}
              color="secondary"
              onClick={() => Disapprove(data)}
              startIcon={<ThumbDown />}
        >
          Disapprove
        </Button>
      </div>

    } else if(data.isCpmApprovedByAgency === false){

      return <div>
        <Button
              variant="contained"
              color="primary"
              className={classes.margin}
              onClick={() => Approve(data)}
              startIcon={<ThumbUp />}
        >
          Approve
        </Button>
      </div>

    } else {
      return (
        <div>
          <Button
              variant="contained"
              color="primary"
              className={classes.margin}
              onClick={() => Approve(data)}
              startIcon={<ThumbUp />}
          >
              Approve
          </Button>

          <Button
              variant="contained"
              className={classes.margin}
              color="secondary"
              onClick={() => Disapprove(data)}
              startIcon={<ThumbDown />}
          >
              Disapprove
          </Button>
        </div>
      )
    }

  }

  return (
    <div>
      <Button type="button" onClick={handleOpen} variant="contained" color="primary">
        <Edit/>
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 100,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <h2>Update CPM approval status</h2>
            {showButtons(data)}
          </div>
        </Fade>
      </Modal>
    </div>
  );
}

export default connect(null,{approveCPMForCampaign, disapproveCPMForCampaign})(EditCPMApprovalForCampaign);